import * as React from 'react'
import { Box } from '@mui/material'

const MobileOnly = ({ children }: { children: React.ReactNode }) => {
  return <Box sx={{ display: { xs: 'block', sm: 'none' } }}>{children}</Box>
}

export default MobileOnly
